exports.TrixEditor = require("./lib/react-trix").TrixEditor;
